import { useMemo } from 'react'
import { useHistory } from 'react-router-dom'

import Text from '@/ui/atoms/Text'

import FormBuilderSettingsCard from '../Components/FormBuilderSettingsCard'
import { CompletePageType } from '../Contexts/FormBuilderContext'
import { CustomCompletePageForm } from './Components/CustomCompletePageForm'
import FormBuilderSettingsCompletePageDocumentConsumer from './Components/FormBuilderSettingsCompletePageDocumentConsumer'
import FormBuilderSettingsCompletePageFormConsumer from './Components/FormBuilderSettingsCompletePageFormConsumer'
import FormBuilderSettingsCompletePagePacketConsumer from './Components/FormBuilderSettingsCompletePagePacketConsumer'

export type CompletePageConsumerModel = {
  completePage: CompletePageType
  setCompletePage: React.Dispatch<
    React.SetStateAction<CompletePageType | undefined>
  >
  isLoading?: boolean
}

export const CustomCompletePage = () => {
  const history = useHistory()
  const isDocument = history.location.pathname.includes('/pdf/')
  const isForm = history.location.pathname.includes('/forms/')

  const Consumer = useMemo(() => {
    if (isDocument) {
      return FormBuilderSettingsCompletePageDocumentConsumer
    }
    if (isForm) {
      return FormBuilderSettingsCompletePageFormConsumer
    }
    return FormBuilderSettingsCompletePagePacketConsumer
  }, [isDocument, isForm])

  return (
    <>
      <FormBuilderSettingsCard
        subtitle={
          <Text $light>
            You can edit the global complete page for all forms and packets in
            settings.
          </Text>
        }
        title="Complete Page"
      >
        <Consumer>
          {({
            completePage,
            setCompletePage,
            isLoading,
          }: CompletePageConsumerModel) => (
            <CustomCompletePageForm
              {...{ completePage, setCompletePage, isLoading }}
            />
          )}
        </Consumer>
      </FormBuilderSettingsCard>
    </>
  )
}
